export const MediaRecorder = window.MediaRecorder;
